export default "__VITE_ASSET__DuESpmNc__"